import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppDocumentos } from '../models/appDocumentos.model';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';
import { LivesSessionHelper } from '../helper/livesSessionHelper';


//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable()
export class AppDocumentosService extends HttpClientBaseService implements IServiceBase<AppDocumentos> {

  constructor(
    _http: HttpClient,
    private _livesSession: LivesSessionHelper
  ) {
    super(_http, '/documents/', '', false);

  }
  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppDocumentos>> {
    throw new Error('Method not implemented.');
  }

  /*   getAllModels(): Observable<AppDocumentos[]> {
      return super.getAll<AppDocumentos[]>();
    } */


  getAllModels(): Observable<AppDocumentos[]> {
    const environmentId = this._livesSession.EnvironmentId;
    const url = `${AppConfig.settings.apiServerPE.apiUrl}doc?orderBy=createdAt&order=desc&fields=environment&operator=eq&values=${environmentId}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición GET y devolver el resultado como un Observable
    return this.http.get<AppDocumentos[]>(url, { headers: headers });
  }

  getAllModelsByCompanyCategory(company: string, category?: string): Observable<AppDocumentos[]> {
    let url = `${AppConfig.settings.apiServerPE.apiUrl}doc?fields=company&operator=eq&values=${company}`;

    if (category) {
      url += `&fields=docCategory&operator=eq&values=${category}`;
    }

    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición GET y devolver el resultado como un Observable
    return this.http.get<AppDocumentos[]>(url, { headers: headers });
  }



  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('es-ES', options);
  }



  getModel(id: any): Observable<AppDocumentos> {
    return super.getSingle<AppDocumentos>(id);
  }

  getOne(doc1: any): Observable<AppDocumentos> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}doc/${doc1}`;

    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición GET y devolver el resultado como un Observable
    return this.http.get<AppDocumentos>(url, { headers: headers });
  }


  public createDoc(data: any): Observable<Object> {

    const url = `${AppConfig.settings.apiServerPE.apiUrl}doc`;

    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición POST y devolver el resultado como un Observable
    return this.http.post<AppDocumentos[]>(url, data, { headers: headers });
  }

  public updateModel(id: string, data: Partial<AppDocumentos>): Observable<AppDocumentos> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}doc/${id}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    const payload = {
      ...data,
      modifiedBy: AppConfig.settings.apiServerPE.system
    };

    // Realizar la petición PATCH y devolver el resultado como un Observable
    return this.http.patch<AppDocumentos>(url, payload, { headers: headers });
  }

  deleteDoc(doc1: any) {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}doc/${doc1}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición POST
    return this.http.delete<AppDocumentos[]>(url, { headers: headers });
  }

}